// extracted by mini-css-extract-plugin
module.exports = {"Blackberry":"#333D47","White":"#FFFFFF","BreakpointFromMedium":"(min-width: 640px)","wrapper":"HeroMessage_wrapper__2LLjQ"};